<script setup lang="ts">
import type { NuxtPage } from '#components'

useHead({
  script: [{ src: 'https://kit.fontawesome.com/48389b5350.js' }],
  meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  link: [{ rel: 'icon', href: '/favicon.ico' }],
  htmlAttrs: {
    lang: 'en',
  },
})
</script>

<template>
  <UApp :toaster="{position: 'bottom-right'}">
    <NuxtLoadingIndicator
      color="repeating-linear-gradient(to right, var(--color-primary-400) 0%, var(--color-primary-500) 50%, var(--color-primary-600) 100%)"
    />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
